/* =============================================================================
   NS いわてバーチャル物産展：追従カートバー（PC/SP）＋バリエーションのミラー選択
   方針：テーマ純正の variant-picker ロジックを再利用する。
        追従バー内のセレクトは「本物の選択UI（.product-form__single-selector）」を
        操作し change を発火させるだけ。価格や variant.id の更新はテーマに任せる。
   作成: 2026-06-13
   ============================================================================= */
(function () {
  "use strict";

  // quick-view など product テンプレ以外、または商品フォームが無い場合は何もしない
  function init() {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var form = section.querySelector("product-form form, .product-form");
    var addBtn = section.querySelector(".product-form__add-button");
    if (!form || !addBtn) return;

    // 既に生成済みなら二重生成しない
    if (document.querySelector(".ns-buybar")) return;

    var titleEl = section.querySelector(".product-meta__title");
    var titleText = (titleEl ? titleEl.textContent : document.title).trim();

    // --- 追従バー DOM ---
    var bar = document.createElement("div");
    bar.className = "ns-buybar";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML =
      '<div class="ns-buybar__inner">' +
      '  <div class="ns-buybar__info">' +
      '    <span class="ns-buybar__title"></span>' +
      '    <span class="ns-buybar__price" data-ns-price></span>' +
      "  </div>" +
      '  <div class="ns-buybar__variants" data-ns-variants></div>' +
      '  <button type="button" class="ns-buybar__add button button--primary" data-ns-add>カートに入れる</button>' +
      "</div>";
    bar.querySelector(".ns-buybar__title").textContent = titleText;
    document.body.appendChild(bar);
    document.body.classList.add("ns-buybar-active");

    var priceTarget = bar.querySelector("[data-ns-price]");
    var variantsWrap = bar.querySelector("[data-ns-variants]");
    var barAdd = bar.querySelector("[data-ns-add]");

    // -------------------------------------------------------------------------
    // 価格の同期：本体の価格表示を読む（セール時は highlight を優先）
    // -------------------------------------------------------------------------
    function readPrice() {
      var box = section.querySelector(".product-form__info-content");
      if (!box) return "";
      var el =
        box.querySelector(".price--highlight") ||
        box.querySelector(".price-list .price") ||
        box.querySelector(".price");
      if (!el) return "";
      // visually-hidden ラベルを除いたテキスト
      var clone = el.cloneNode(true);
      clone.querySelectorAll(".visually-hidden").forEach(function (n) { n.remove(); });
      return clone.textContent.replace(/\s+/g, " ").trim();
    }
    function syncPrice() { var p = readPrice(); if (p) priceTarget.textContent = p; }
    // テーマの価格更新は非同期（product-rerender）。数回ポーリングして確実に拾う
    function syncPriceSoon() { [120, 350, 700, 1200].forEach(function (t) { setTimeout(syncPrice, t); }); }

    // -------------------------------------------------------------------------
    // バリエーションのミラー：本体の各オプションを <select> として複製
    // 本体が radio 群でも select でも、option value(=value.id) を value に持つ
    // -------------------------------------------------------------------------
    var mirrors = []; // { name, select, getRealValue, setReal }

    function buildMirrors() {
      variantsWrap.innerHTML = "";
      mirrors = [];
      var picker = section.querySelector("variant-picker");
      if (!picker) return; // 単一バリエーション商品（option 無し）→ ミラー不要

      var options = picker.querySelectorAll(".product-form__option");
      options.forEach(function (optEl) {
        // この option を制御する実体（radio 群 もしくは select）
        var realSelect = optEl.querySelector("select.product-form__single-selector");
        var radios = optEl.querySelectorAll('input[type="radio"].product-form__single-selector');

        var name, values; // values: [{value, label, available}]
        if (realSelect) {
          name = realSelect.getAttribute("name");
          values = Array.prototype.map.call(realSelect.options, function (o) {
            return { value: o.value, label: o.textContent.trim(), available: !o.disabled };
          });
        } else if (radios.length) {
          name = radios[0].getAttribute("name");
          values = Array.prototype.map.call(radios, function (r) {
            var lab = optEl.querySelector('label[for="' + r.id + '"]');
            var available = !(r.closest(".block-swatch--disabled, .color-swatch--disabled, .variant-swatch--disabled"));
            return { value: r.value, label: (lab ? lab.textContent : r.value).trim(), available: available };
          });
        } else {
          return; // 制御不能な option はスキップ
        }

        // ミラー <select> 生成
        var sel = document.createElement("select");
        sel.className = "ns-buybar__select";
        sel.setAttribute("aria-label", titleText + " オプション");
        values.forEach(function (v) {
          var o = document.createElement("option");
          o.value = v.value;
          o.textContent = v.available ? v.label : v.label + "（在庫切れ）";
          sel.appendChild(o);
        });
        variantsWrap.appendChild(sel);

        function getRealValue() {
          if (realSelect) return realSelect.value;
          var checked = optEl.querySelector('input[type="radio"].product-form__single-selector:checked');
          return checked ? checked.value : null;
        }
        function setReal(val) {
          if (realSelect) {
            realSelect.value = val;
            realSelect.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            var r = optEl.querySelector('input[type="radio"].product-form__single-selector[value="' + val + '"]');
            if (r && !r.checked) {
              r.checked = true;
              r.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        }

        sel.value = getRealValue();
        // バー→本体
        sel.addEventListener("change", function () {
          setReal(sel.value);
          syncPriceSoon();
        });

        mirrors.push({ name: name, select: sel, getRealValue: getRealValue, optEl: optEl });
      });
    }

    // 本体→バー（ユーザーが本体で選択を変えた／テーマが DOM 再描画した場合）
    function reflectFromReal() {
      mirrors.forEach(function (m) {
        var v = m.getRealValue();
        if (v != null && m.select.value !== v) m.select.value = v;
      });
      syncPrice();
    }

    buildMirrors();
    syncPrice();

    // 本体側の変更を監視（radio/select の change）
    section.addEventListener("change", function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("product-form__single-selector")) {
        reflectFromReal();
        syncPriceSoon();
      }
    }, true);

    // 価格表示エリアの再描画を監視して、バー価格を常に同期（最も確実）
    var infoItem = section.querySelector(".product-block-list__item--info") || section;
    if ("MutationObserver" in window) {
      var priceTimer = null;
      var priceMo = new MutationObserver(function () {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(syncPrice, 80);
      });
      priceMo.observe(infoItem, { childList: true, subtree: true, characterData: true });
    }

    // テーマが variant-picker の innerHTML を差し替えるケースに追従して再構築
    var picker = section.querySelector("variant-picker");
    if (picker && "MutationObserver" in window) {
      var rebuildTimer = null;
      var mo = new MutationObserver(function () {
        clearTimeout(rebuildTimer);
        rebuildTimer = setTimeout(function () {
          buildMirrors();
          syncPrice();
        }, 120);
      });
      mo.observe(picker, { childList: true, subtree: true });
    }

    // -------------------------------------------------------------------------
    // 追加ボタン：本物の Add ボタンを発火（テーマの ajax カート等をそのまま使う）
    // -------------------------------------------------------------------------
    barAdd.addEventListener("click", function () {
      var real = section.querySelector(".product-form__add-button");
      if (!real || real.disabled) return;
      real.click();
      bar.classList.add("is-clicking");
      setTimeout(function () { bar.classList.remove("is-clicking"); }, 800);
    });

    // 売り切れ等で本体 Add が disabled の時はバーも無効化
    function syncAddState() {
      var real = section.querySelector(".product-form__add-button");
      var disabled = !real || real.disabled;
      barAdd.disabled = disabled;
      barAdd.textContent = real ? real.textContent.trim() || "カートに入れる" : "カートに入れる";
    }
    syncAddState();

    // -------------------------------------------------------------------------
    // 表示制御：本体 Add ボタンが画面外に出たらバー表示（IntersectionObserver）
    // -------------------------------------------------------------------------
    function setupVisibility() {
      var real = section.querySelector(".product-form__add-button");
      if (!real) { setTimeout(setupVisibility, 400); return; }
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.setAttribute("aria-hidden", entry.isIntersecting ? "true" : "false");
          });
          syncAddState();
        }, { threshold: 0 });
        io.observe(real);
      } else {
        // フォールバック：スクロール量で判定
        window.addEventListener("scroll", function () {
          var r = real.getBoundingClientRect();
          bar.setAttribute("aria-hidden", r.top < window.innerHeight && r.bottom > 0 ? "true" : "false");
        }, { passive: true });
      }
    }
    setupVisibility();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
